import 'react-app-polyfill/ie11'
import 'core-js/features/array/find'
import 'core-js/features/array/includes'
import 'core-js/features/number/is-nan'

import shim from 'object.values/shim'
import 'string-includes-polyfill'

shim()
